import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { couponsApi, type CreateCouponBody } from '@/api/coupons.api';

export const couponKeys = {
  all: ['coupons'] as const,
  list: () => [...couponKeys.all, 'list'] as const,
};

export function useCoupons() {
  return useQuery({ queryKey: couponKeys.list(), queryFn: () => couponsApi.list() });
}

export function useCreateCoupon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateCouponBody) => couponsApi.create(body),
    onSuccess: () => {
      toast.success('Cupón creado');
      qc.invalidateQueries({ queryKey: couponKeys.all });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al crear el cupón'),
  });
}

export function useUpdateCoupon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<CreateCouponBody> }) =>
      couponsApi.update(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: couponKeys.all });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al actualizar'),
  });
}

export function useDeleteCoupon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => couponsApi.remove(id),
    onSuccess: () => {
      toast.success('Cupón eliminado');
      qc.invalidateQueries({ queryKey: couponKeys.all });
    },
    onError: (err: Error) => toast.error(err.message || 'Error al eliminar'),
  });
}
